import { createTheme } from "@mui/material/styles";

const lightTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      xsm: 400,
      sm: 600,
      smd: 750,
      md: 900,
      mlg: 1050,
      lg: 1200,
      lxl: 1350,
      xl: 1536,
    },
  },
  palette: {
    mode: "light",
    primary: {
      // main: "#3B96D5",
      main: "#0C4278",
      secondary: "#0C4278",
    },
    secondary: {
      main: "#ff9100",
    },
    background: {
      default: "#F7F7F7",
      paper: "#ffffff",
      noneditable: "#787880",
    },
    text: {
      primary: "#000000",
      secondary: "#3B3B3B",
      heading1: "#292929",
      heading2: "#454545",
      bodytext: "#959595",
    },
    outline: {
      border: "#D9D9D9",
    },
    button: {
      primary: "#1F72C3",
      secondary: "#3B96D5",
      right: "#62D177",
      wrong: "#D6513C",
    },
    border: {
      primary: "#D9D9D9",
      secondary: "#E54B3E",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: "2.5rem",
      fontWeight: 700,
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 700,
    },
    h3: {
      fontSize: "1.75rem",
      fontWeight: 600,
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 600,
    },
    h5: {
      fontSize: "1.25rem",
      fontWeight: 500,
    },
    h6: {
      fontSize: "1rem",
      fontWeight: 500,
    },
    body1: {
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: 1.5,
    },
    body2: {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: 1.5,
    },
    button: {
      fontSize: "1rem",
      textTransform: "none", // Disable uppercase
      fontWeight: 500,
      backgroundColor: "GrayText",
    },
    caption: {
      fontSize: "0.75rem",
      fontWeight: 400,
    },
  },
});

export default lightTheme;
